import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { UserContextService } from '../../services/user-context.service';
import { AuthNavigationService } from '../../services/auth-navigation.service';

@Component({
  selector: 'app-auth-callback',
  standalone: false,
  template: `
    <div class="container-fluid d-flex justify-content-center align-items-center" style="min-height: 100vh;">
      <div class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3">Completing authentication...</p>
      </div>
    </div>
  `
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private userContext: UserContextService,
    private authNav: AuthNavigationService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      const code = this.route.snapshot.queryParams['code'];
      const state = this.route.snapshot.queryParams['state'];
      const error = this.route.snapshot.queryParams['error'];

      if (error) {
        this.authNav.navigateToNotAuthorizedPermissions();
        return;
      }

      if (!code || !state) {
        this.authNav.navigateToNotAuthorizedPermissions();
        return;
      }

      await this.authService.handleCallbackAsync(code, state);

      if (!this.authService.hasAccess()) {
        this.authNav.navigateToNotAuthorizedPermissions();
        return;
      }

      await this.userContext.initializeAsync();

      if (this.userContext.hasNoTenants) {
        this.authNav.navigateToNotAuthorizedNoTenants();
      } else if (this.userContext.shouldShowTenantSelection) {
        this.authNav.navigateToAssociationSelection();
      } else if (this.userContext.sourceId) {
        this.authNav.navigateToFlaggedContacts();
      } else {
        this.authNav.navigateToNotAuthorizedNoTenants();
      }
    } catch {
      this.authNav.navigateToNotAuthorizedPermissions();
    }
  }
}
